import React from 'react';

export type RegisterFormT = {
  last_name: string;
  first_name: string;
  company_name: string;
  company_slug: string;
  company_registration: string;
  contact: string;
  email: string;
};

/* ---------- Slug Props  ---------- */
export type SlugInputProps = {
  value: string;
  onChange: (v: string) => void;
  suffix: string;
  placeholder?: string;
  maxLength?: number;
  error?: React.ReactNode;
};

export const MAX_COMPANY_NAME = 30;

/* ---------- helpers ---------- */
export const sanitizeURL = (raw = ''): string => {
  let s = raw.toLowerCase().replace(/[^a-z0-9\s-]/g, '');
  s = s.replace(/([a-z0-9]+)(-+)([a-z0-9])\s+/g, (_m, p1, hyphens, p3) => {
    return `${p1}-${p3}${hyphens}`;
  });
  // collapse any hyphen+space combos into single hyphen (handles "- " or " - ")
  s = s.replace(/\s*-\s*/g, '-');
  // convert remaining spaces to hyphen (one-to-one)
  s = s.replace(/\s/g, '-');
  // trim hyphens at edges
  s = s.replace(/^-+|-+$/g, '');
  return s;
};

export const makeAutoSlug = (companyName: string) => sanitizeURL(companyName);

// Form Initial value
export const registerInitialValues: RegisterFormT = {
  last_name: '',
  first_name: '',
  company_name: '',
  company_slug: '',
  company_registration: '',
  contact: '',
  email: ''
};

export const getDomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  if (parts.length > 2) {
    return parts.slice(-2).join('.');
  }
  return hostname;
};
